import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    // Check localStorage for saved preference
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme === 'dark';
    }
    // Default to dark mode
    return true;
  });

  // Track if user has explicitly selected a theme (for first-time user modal)
  // Also consider existing users (who have 'theme' key) as having selected
  const [hasSelectedTheme, setHasSelectedTheme] = useState(() => {
    const explicitlySelected = localStorage.getItem('hasSelectedTheme') === 'true';
    const existingUser = localStorage.getItem('theme') !== null;
    return explicitlySelected || existingUser;
  });

  useEffect(() => {
    // Save preference to localStorage
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    
    // Apply theme class to document root
    if (isDarkMode) {
      document.documentElement.classList.add('dark-mode');
    } else {
      document.documentElement.classList.remove('dark-mode');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  // Confirm theme selection (called when user clicks Continue in theme selector modal)
  const confirmThemeSelection = () => {
    localStorage.setItem('hasSelectedTheme', 'true');
    setHasSelectedTheme(true);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, setIsDarkMode, toggleTheme, hasSelectedTheme, confirmThemeSelection }}>
      {children}
    </ThemeContext.Provider>
  );
};


